export default __webpack_public_path__ + "static/media/papua_flag.ae683b2b.png";